import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useCallback,
} from "react";
import Layout from "../../../components/molecules/Layout";
import SearchGrid from "../../../components/molecules/Search/SearchGrid";
import SearchCard from "../../../components/atoms/SearchCard";
import GlobalContext from "../../../context/GlobalContext";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import Menu from "@material-ui/core/Menu";
import MenuList from "@material-ui/core/MenuList";
import qs from "qs";
import "./search.css";
import {
  getSavedSearch,
  getSearch,
  saveSearch,
  updateSavedSearch,
} from "../../../API/search";
import { toast } from "react-toastify";
import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  Popover,
  Slider,
  Tab,
  Tabs,
  useForkRef,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import CheckBox from "../../../components/atoms/CheckBox";
import { indexOf, min } from "lodash";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useToggle from "../../../utils/useToggle";
import { stateCode } from "../../../utils";
import CustomInput from "../../../components/atoms/Inputs/CustomInput";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import PriceInput from "../../../components/atoms/Inputs/PriceInput";
import { numberWithCommas, callNumber } from "../../../utils";
import { getLocation } from "../../../API/userData";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useLocation, useHistory } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Pagination from "../../../components/atoms/Pagination";
import SearchFilter from "../../../components/molecules/Search/SearchFilter";
import CustomSelect from "../../../components/atoms/Inputs/CustomSelect";
import PrimaryButton from "../../../components/atoms/PrimaryButton";
import RadioBox from "../../../components/atoms/RadioBox";
import MapComponent from "../../../components/molecules/Search/mapRefer";
import SecondaryButton from "../../../components/atoms/SecondaryButton";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import * as Yup from "yup";
import Featured from "../Featured";
import { debounce } from "lodash";
import socket from "../../../utils/socket";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: "275px",
    marginBottom: "10px",
    height: "45px",
  },
  mobileFormControl: {
    margin: theme.spacing(1),
    width: "163px",
    marginBottom: "5px",
  },
  formControldiv: {
    width: "300px",
  },
  mobileFormControldiv: {
    width: "170px",
    marginBottom: "3px",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    //border: "2px solid #000",
    boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
  },
}));

function getModalStyle() {
  const top = 100;
  const left = 98;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const Search = (props) => {
  let propertyType_val = "";
  let productType_val = "";
  const location = useLocation();
  const classes = useStyles();
  const [drawSearch, setDrawSearch] = useState(true);
  const [viewProperties, setViewProperties] = useState([]);
  const [viewAllProperties, setViewAllProperties] = useState([]);
  const [viewPropertyLocations, setViewPropertyLocations] = useState([]);
  const [propertyType, setPropertyType] = useState("");
  const [triggered, setTriggered] = useState(true);
  const [filterCount, setFilterCount] = useState(0);
  const [isBoundSet, setIsBoundSet] = useState(false);
  const [mobileSelectOpen, setMobileSelectOpen] = useState(false);
  const [mobilePropertyPopupOpen, setMobilePropertyPopupOpen] = useState(false);
  const [mobileSelectedPropertyId, setMobileSelectedPropetyId] = useState("");
  const [selectedLocationBound, setSelectedLocationBound] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isbathChecked, setIsbathChecked] = useState(false);
  const [modalStyle] = useState(getModalStyle);
  const history = useHistory();

  const [sqt, setSqt] = useState({
    minSize: "",
    maxSize: "",
  });

  const [beds, setBeds] = useState({
    minBeds: "",
    maxBeds: "",
  });

  const [baths, setBaths] = useState({
    minBaths: "",
    maxBaths: "",
  });

  const [body, setBody] = useState(undefined);
  const [isLoaded, setLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [getCount, setCount] = useState(0);
  const [propertyLoc, setPropertyLoc] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [page, setPage] = useState(1);
  const { userLocation, userLoggedIn, headerLocation, storeDetails } =
    useContext(GlobalContext);
  const [state, setState] = useState({
    right: false,
  });
  const width = useMediaQuery("(min-width:992px)");
  const [map, toggleMap] = useToggle(false);
  const store_id = window.location.pathname.split("/")[1];
  const site_id = localStorage.getItem("site_id");
  const [open, setOpen] = useState({
    proType: false,
    priceRange: false,
    count: false,
    homeType: false,
    more: false,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [btnColor, setBtnColor] = useState({ btn_color: "", btn_type: "" });
  const [btnColor1, setBtnColor1] = useState({ btn_color: "", btn_type: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const isResetting = useRef(false);

  // Add mapRef to access zoomToStateByName function
  const mapRef = useRef(null);

  const debouncedSetBodyState = debounce(() => {
    // Prevent running during reset operations
    if (isResetting.current) {
      return;
    }

    if (props.location.search) {
      let query = qs.parse(window.location.search?.slice(1));

      setPage(Number(query.page) || 1);
      setBody({
        page: query.page || 1,
        limit: 6,
        // cities: query.cities ? query.cities.split(",") : "",
        title: query.title || "",
        ids: query.ids ? query.ids.split(",") : "",
        sortby: query.sortby || "1",
        maxPrice: query.maxPrice || "",
        minPrice: query.minPrice || "",
        status: query.status ? query.status.split(",") : "",
        listing_type: query.listing_type ? query.listing_type.split(",") : "",
        occupency_type: query.occupency_type
          ? query.occupency_type.split(",")
          : "",
        minbeds: query.minBed || "",
        maxSqft: query.maxSqft || "",
        minSqft: query.minSqft || "",
        minLotSize: query.minLotSize || "",
        maxLotSize: query.maxLotSize || "",
        minYearbuilt: query.minYearbuilt || "",
        maxYearbuilt: query.maxYearbuilt || "",
        parking: query.parking || "",
        exact_bathroom: query.exact_bathroom ? query.exact_bathroom : false,
        exact_bedroom: query.exact_bedroom ? query.exact_bedroom : false,
        maxbeds: query.maxBed || "",
        garage: query.garage == "yes" ? "yes" : "no",
        is_open_house: query.is_open_house == "yes" ? "yes" : "no",
        is_3D_Tour: query.is_3D_Tour == "yes" ? "yes" : "no",
        keywords: query.keywords ? query.keywords : "",
        minbathroom: query.minBath || "",
        bedroom: query.bedroom || "",
        bathroom: query.bathroom || "",
        maxbathroom: query.maxBath || "",
        property_type: query.property_type
          ? query.property_type.split(",")
          : "",
        product_type: query.product_type ? query.product_type.split(",") : "",
        minSize: query.minSize ? query.minSize.toString() : "",
        maxSize: query.maxSize ? query.maxSize.toString() : "",
        type: query.type ? query.type.split(",") : "",
        rPrice: query.rPrice,
        bound:
          query.north && query.south && query.east && query.west
            ? {
                north: query.north,
                south: query.south,
                east: query.east,
                west: query.west,
              }
            : {},
        zoom_level: query.zoom_level || "13",
        initial: query.initial || false,
        searchbar: query.searchbar || "",
        search_url: window.location.href,
      });
      setIsChecked(query.exact_bedroom == "true" ? true : false);
      setIsbathChecked(query.exact_bathroom == "true" ? true : false);
      setSelectedLocationBound({
        north: query.north,
        south: query.south,
        east: query.east,
        west: query.west,
      });
    }
  }, 100);

  const getDefaultBody = () => {
    // First check URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Get values from URL or fall back to defaults
    return {
      page: 1,
      limit: 6,
      status: urlParams.get("status") || "",
      lat: parseFloat(urlParams.get("lat")) || global.defaultLat,
      long: parseFloat(urlParams.get("long")) || global.defaultLong,
      north: parseFloat(urlParams.get("north")) || global.defaultNorth,
      south: parseFloat(urlParams.get("south")) || global.defaultSouth,
      east: parseFloat(urlParams.get("east")) || global.defaultEast,
      west: parseFloat(urlParams.get("west")) || global.defaultWest,
      radius: parseInt(urlParams.get("radius")) || 20,
      load: urlParams.get("load") === "true" || false,
      zoom: urlParams.get("zoom") === "true" || false,
      title: urlParams.get("title") || "United States",
      cities: urlParams.get("cities") || "",
      state: urlParams.get("state") || "",
      initial: urlParams.get("initial") === "true" || false,
      zoom_level:
        parseInt(urlParams.get("zoom_level")) || global.defaultZoomLevel,
      searchbar: urlParams.get("searchbar") || "",
      ids: urlParams.get("ids") ? urlParams.get("ids").split(",") : "",
      sortby: urlParams.get("sortby") || "1",
      maxPrice: urlParams.get("maxPrice") || "",
      minPrice: urlParams.get("minPrice") || "",
      listing_type: urlParams.get("listing_type")
        ? urlParams.get("listing_type").split(",")
        : "",
      occupency_type: urlParams.get("occupency_type")
        ? urlParams.get("occupency_type").split(",")
        : "",
      minbeds: urlParams.get("minBed") || "",
      maxSqft: urlParams.get("maxSqft") || "",
      minSqft: urlParams.get("minSqft") || "",
      minLotSize: urlParams.get("minLotSize") || "",
      maxLotSize: urlParams.get("maxLotSize") || "",
      minYearbuilt: urlParams.get("minYearbuilt") || "",
      maxYearbuilt: urlParams.get("maxYearbuilt") || "",
      parking: urlParams.get("parking") || "",
      exact_bathroom: urlParams.get("exact_bathroom") === "true" || false,
      exact_bedroom: urlParams.get("exact_bedroom") === "true" || false,
      maxbeds: urlParams.get("maxBed") || "",
      garage: urlParams.get("garage") === "yes" ? "yes" : "no",
      is_open_house: urlParams.get("is_open_house") === "yes" ? "yes" : "no",
      is_3D_Tour: urlParams.get("is_3D_Tour") === "yes" ? "yes" : "no",
      keywords: urlParams.get("keywords") || "",
      minbathroom: urlParams.get("minBath") || "",
      bedroom: urlParams.get("bedroom") || "",
      bathroom: urlParams.get("bathroom") || "",
      maxbathroom: urlParams.get("maxBath") || "",
      property_type: urlParams.get("property_type")
        ? urlParams.get("property_type").split(",")
        : "",
      product_type: urlParams.get("product_type")
        ? urlParams.get("product_type").split(",")
        : "",
      minSize: urlParams.get("minSize") || "",
      maxSize: urlParams.get("maxSize") || "",
      type: urlParams.get("type") ? urlParams.get("type").split(",") : "",
      rPrice: urlParams.get("rPrice"),
      search_url: window.location.href,
    };
  };

  useEffect(() => {
    if (body?.product_type == "all") {
      let query = new URLSearchParams(props.location.search);
      query?.set(
        "product_type",
        [
          "Bank Owned",
          "Foreclosure",
          "Short Sale",
          "Traditional",
          "all",
          "auction",
        ].toString(),
      );
      props.history.replace({
        pathname: props.location.pathname,
        search: "?" + query.toString(),
      });
    }
  }, [body?.product_type]);

  const searchURL = window.location.href;

  const copy = () => window.navigator.clipboard.writeText(searchURL);

  useEffect(() => {
    if (body?.product_type == "all") {
      let query = new URLSearchParams(props.location.search);
      query?.set(
        "product_type",
        [
          "Bank Owned",
          "Foreclosure",
          "Short Sale",
          "Traditional",
          "all",
          "auction",
        ].toString(),
      );
      props.history.replace({
        pathname: props.location.pathname,
        search: "?" + query.toString(),
      });
    }
  }, [body?.product_type]);

  const searchPageChange = (event, page) => {
    setPage(page);
    let url = new URLSearchParams(window.location.search);
    url.set("page", page);
    getAllProperties(null, { ...body, page: page });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + url.toString(),
    });
  };

  const [searchDetails, setSearchDetails] = useState({
    searchName: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);
    const searchName = queryParams.get("searchbar");
    if (searchName) {
      setSearchDetails((prevDetails) => ({ ...prevDetails, searchName }));
    }
  }, [history.location.search]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const validationSchema = Yup.object({
    searchName: Yup.string()
      .required("Search name cannot be empty")
      .min(3, "Search name should be at least 3 characters"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      searchName: searchDetails.searchName || "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (userLoggedIn.get === false) {
        formik.setFieldError("searchName", "Login to save search");
        return;
      }
      let savedSearches = [];
      try {
        savedSearches = await getSavedSearch(site_id);
        savedSearches = savedSearches.result || [];
      } catch (e) {
        savedSearches = [];
      }
      const isDuplicate = savedSearches.some(
        (search) =>
          (search.cities &&
            search.cities.trim().toLowerCase() ===
              values.searchName.trim().toLowerCase()) ||
          (search.url &&
            search.url.split("?")[0] === window.location.href.split("?")[0]),
      );

      if (isDuplicate) {
        formik.setFieldError("searchName", "This search is already saved.");
        toast.error("This search is already saved.");
        return;
      }

      const body = {
        title: values.searchName,
        site_id,
        search_url: window.location.href,
      };
      const data =
        values.searchName != ("" || undefined)
          ? await saveSearch(body, site_id)
          : await updateSavedSearch(body, site_id);

      if (data.status === true) {
        toast.success("Search saved successfully");
        setAnchorEl(null);
      } else {
        formik.setFieldError("searchName", "Unable to save search");
      }
    },
  });
  const onKeyDown = (e) => {
    e.stopPropagation();
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        anchorEl &&
        !anchorEl.contains(event.target) &&
        !event.target.closest(".saved-menu")
      ) {
        setAnchorEl(null);
      }
    };

    if (openMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenu, anchorEl]);

  const getAllProperties = useCallback(
    async (boundsArray, newBody) => {
      if (isResetting.current) {
        return;
      }

      setIsLoading(true);
      let property = getDefaultBody();

      // Ensure default filters are always applied
      const defaultStatus = property.status || ["open"];

      if (boundsArray) {
        property.boundsArray = boundsArray;
      } else if (newBody) {
        property = { ...getDefaultBody(), ...newBody };

        // Make sure status filter is always applied
        if (!property.status || property.status.length === 0) {
          property.status = defaultStatus;
        }
      } else if (body?.bound) {
        property.bound = body.bound;

        // Make sure status filter is always applied
        if (!property.status || property.status.length === 0) {
          property.status = defaultStatus;
        }
      }

      // Keep coordinate and bound fields synchronized to avoid mixed old/new payloads.
      if (newBody?.bound) {
        property.north = newBody.bound.north;
        property.south = newBody.bound.south;
        property.east = newBody.bound.east;
        property.west = newBody.bound.west;
      } else if (property?.bound) {
        property.north = property.bound.north;
        property.south = property.bound.south;
        property.east = property.bound.east;
        property.west = property.bound.west;
      }

      if (typeof newBody?.lat !== "undefined") {
        property.lat = newBody.lat;
      }

      if (typeof newBody?.lng !== "undefined") {
        property.lng = newBody.lng;
        property.long = newBody.lng;
      } else if (typeof newBody?.long !== "undefined") {
        property.lng = newBody.long;
        property.long = newBody.long;
      } else if (
        typeof property?.lng !== "undefined" &&
        property.lng !== "" &&
        property.lng !== null
      ) {
        property.long = property.lng;
      } else if (
        typeof property?.long !== "undefined" &&
        property.long !== "" &&
        property.long !== null
      ) {
        property.lng = property.long;
      }

      let data = await getSearch(property, site_id);

      if (data.status == true) {
        const productDetails = data?.result?.productdetails || [];
        const mapProperties = data?.result?.mapProperties || [];
        const mergedMapPropertiesById = new Map();

        [...mapProperties, ...productDetails].forEach((item) => {
          if (item && typeof item.id !== "undefined" && item.id !== null) {
            mergedMapPropertiesById.set(item.id, item);
          }
        });

        const mapPropertiesWithFallback = Array.from(
          mergedMapPropertiesById.values(),
        );

        setCount(data["total_count"]);
        setViewProperties([...productDetails]);
        setViewAllProperties([...mapPropertiesWithFallback]);
        setTriggered(true);
      }
      if (data.result.productdetails.length === 0) {
        const url = new URLSearchParams(window.location.search);
        url.set("page", "1");

        props.history.replace({
          pathname: props.location.pathname,
          search: "?" + url.toString(),
        });

        setPage(1);
        return;
      }
      setIsLoading(false);
    },
    [site_id, body, props.location.search],
  );

  useEffect(() => {
    setIsLoading(false);
  }, [viewProperties]);

  const handlePropertyUpdate = useCallback((data) => {
    setViewProperties((currentProperties) => {
      const index = currentProperties.findIndex(
        (s) => s.id === parseInt(data.productId, 10),
      );

      if (index === -1) return currentProperties;

      const updatedProperties = [...currentProperties];
      const productToChange = { ...updatedProperties[index] };

      if (Number(data.belowFive) === 1) {
        productToChange.date_closed = data.belowFiveIncrement;
      }

      updatedProperties[index] = {
        ...productToChange,
        bidcount: data.bidCount,
        bidCount: data.bidCount,
        wprice: data.wPrice,
      };

      return updatedProperties;
    });

    setViewAllProperties((currentProperties) => {
      const index = currentProperties.findIndex(
        (s) => s.id === parseInt(data.productId, 10),
      );

      if (index === -1) return currentProperties;

      const updatedProperties = [...currentProperties];
      const productToChange = { ...updatedProperties[index] };

      if (Number(data.belowFive) === 1) {
        productToChange.date_closed = data.belowFiveIncrement;
      }

      updatedProperties[index] = {
        ...productToChange,
        bidcount: data.bidCount,
        bidCount: data.bidCount,
        wprice: data.wPrice,
      };

      return updatedProperties;
    });
  }, []);

  useEffect(() => {
    // Set up socket listener
    const handleBidAddTime = (data) => {
      handlePropertyUpdate(data);
    };

    socket.on("bidAddtime", handleBidAddTime);

    // Cleanup socket listener
    return () => {
      socket.off("bidAddtime", handleBidAddTime);
    };
  }, [handlePropertyUpdate]);

  const onSortBy = (e) => {
    let query = new URLSearchParams(props.location.search);
    query.set("page", 1);
    query.set("sortby", e.target.value);
    getAllProperties(null, { ...body, sortby: e.target.value, page: 1 });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
    return false;
  };

  const filterChangeFunc = (e, key, type) => {
    let query = new URLSearchParams(window.location.search);
    if (key === "bedroom") {
      setBtnColor({ btn_color: e, btn_type: key });
      if (e !== "") {
        query.set("exact_bedroom", isChecked);
      }
    } else if (key === "bathroom") {
      setBtnColor1({ btn_color: e, btn_type: key });
      if (e !== "") {
        query.set("exact_bathroom", isbathChecked);
      }
    }

    query.set("page", 1);
    let allProperty = "";
    if (type == "check") {
      allProperty = body[key] == "yes" ? "no" : "yes";
    } else if (type == "button") {
      allProperty = e;
    } else {
      allProperty = e.target.value;
    }

    query.set(key, allProperty);
    getAllProperties(null, {
      ...body,
      [key]: allProperty,
      page: 1,
      exact_bedroom: key === "bedroom" && e !== "" ? isChecked || "" : "",
      exact_bathroom: key === "bathroom" && e !== "" ? isbathChecked || "" : "",
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
  };

  const [scrollTop, setScrollTop] = useState(false);

  useEffect(() => {
    function onScroll() {
      let currentPosition =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 480;
      setScrollTop(currentPosition);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  useEffect(() => {
    if ((viewAllProperties || viewProperties) && triggered) {
      const sourceProperties =
        viewAllProperties && viewAllProperties.length > 0
          ? viewAllProperties
          : viewProperties || [];
      let mapLocations = [];
      sourceProperties.length > 0 &&
        window.google &&
        window.google.maps &&
        sourceProperties.map((property) => {
          const lat = parseFloat(property?.lat);
          const lng = parseFloat(
            typeof property?.lng !== "undefined" &&
              property?.lng !== null &&
              property?.lng !== ""
              ? property.lng
              : property?.long,
          );

          if (!isNaN(lat) && !isNaN(lng)) {
            mapLocations.push({
              ...property,
              latlng: new window.google.maps.LatLng(lat, lng),
            });
          }
        });
      setViewPropertyLocations(mapLocations);
      sourceProperties.length > 0 && setMobileSelectOpen(false);
    }
  }, [viewAllProperties, viewProperties, triggered]);

  const handleMapCenterChange = (newCenter, newBound, changeZoom, from) => {
    if (!newBound || !newCenter) return;

    let url = new URLSearchParams(window.location.search);
    let updatedBody = {};
    const currentPage = Number(url.get("page")) || 1;
    const status = url.get("status");
    const currentSearchbar = url.get("searchbar") || "";
    if (newCenter) {
      url.set("lat", newCenter.lat);
      url.set("long", newCenter.lng);

      updatedBody = {
        ...updatedBody,
        lat: newCenter.lat,
        long: newCenter.lng,
        lng: newCenter.lng,
      };
    }

    if (newBound) {
      url.set("north", newBound.north);
      url.set("south", newBound.south);
      url.set("east", newBound.east);
      url.set("west", newBound.west);

      updatedBody = {
        ...updatedBody,
        north: newBound.north,
        south: newBound.south,
        east: newBound.east,
        west: newBound.west,
        bound: {
          north: newBound.north,
          south: newBound.south,
          east: newBound.east,
          west: newBound.west,
        },
      };
    }

    if (changeZoom) {
      url.set("zoom_level", changeZoom);

      updatedBody = {
        ...updatedBody,
        zoom_level: changeZoom,
      };
    }

    url.set("cities", "");
    url.set("state", "");
    url.set("initial", false);

    updatedBody = {
      ...updatedBody,
      searchbar: currentSearchbar,
    };
    getAllProperties(null, {
      ...body,
      ...updatedBody,
      status: status?.split(",") || body?.status || "",
      searchbar: currentSearchbar,
      page: currentPage,
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + url.toString(),
    });
  };

  const handleMultipleBounds = (boundsArray, from) => {
    getAllProperties(boundsArray);
  };

  const handleModalClose = () => {
    setMobilePropertyPopupOpen(false);
  };

  const bathroomPartions = [
    {
      label: "Any",
      name: "",
    },
    {
      label: "1+",
      name: 1,
    },
    {
      label: "1.5+",
      name: 1.5,
    },
    {
      label: "2",
      name: 2,
    },
    {
      label: "3",
      name: 3,
    },
    {
      label: "4",
      name: 4,
    },
  ];
  const bedroomPartions = [
    {
      label: "Any",
      name: "",
    },
    {
      label: "1",
      name: 1,
    },
    {
      label: "2",
      name: 2,
    },
    {
      label: "3",
      name: 3,
    },
    {
      label: "4",
      name: 4,
    },
    {
      label: "5",
      name: 5,
    },
  ];

  const houseTypes = [
    {
      label: "Single Family",
      name: "Single Family",
    },
    {
      label: "Condo/Townhouse/Co-Op",
      name: "Condo/Townhouse/Co-Op",
    },
    {
      label: "Duplex",
      name: "Duplex",
    },
    {
      label: "Multifamily",
      name: "Multifamily",
    },
    {
      label: "Mobile",
      name: "Mobile",
    },
    {
      label: "Manufactured",
      name: "Manufactured",
    },
    {
      label: "Modular",
      name: "Modular",
    },
    {
      label: "Lots/Lands ",
      name: "Lots/Lands ",
    },
  ];

  const propertyStatus = [
    {
      label: "Coming Soon",
      name: "coming_soon",
    },
    {
      label: "Active",
      name: "open",
    },
    {
      label: "Offer Pending",
      name: "pending",
    },
    {
      label: "Under Contract",
      name: "under_contract",
    },
    {
      label: "Sold",
      name: "sold",
    },
  ];

  const occupancyOptions = [
    {
      label: "Vacant",
      name: "vacant",
    },
    {
      label: "Occupied",
      name: "occupied",
    },
    {
      label: "Unknown",
      name: "unknown",
    },
  ];

  const assetTypeItems = [
    { name: "Bank Owned", label: "Bank Owned" },
    { name: "Foreclosure", label: "Foreclosure" },
    { name: "Short Sale", label: "Short Sale" },
    { name: "Traditional", label: "Traditional" },
  ];
  // Filter Button section Functions
  const anchorRefs = useRef({});
  const [anchorSetEl, setAnchorSetEl] = useState(null);
  const [checkedItems, setCheckedItems] = useState(houseTypes);

  const handleClose = (event) => {
    // if (anchorRef.current && anchorRef.current.contains(event.target)) {
    //   return;
    // }
    // setOpen(false);
    setAnchorSetEl(null);
  };

  const handleCheckboxChange = (e) => {
    let query = new URLSearchParams(window.location.search);
    query.set("page", 1);
    let allProperty = [];
    if (body.property_type.includes(e.target.value)) {
      allProperty = body.property_type.filter(
        (data) => data !== e.target.value,
      );
    } else {
      allProperty = [...body.property_type, e.target.value];
    }

    propertyType_val = allProperty;

    query.set(
      "property_type",
      allProperty.length ? allProperty.toString() : "",
    );
    getAllProperties(null, {
      ...body,
      property_type: allProperty.length ? allProperty : "",
      page: 1,
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
  };

  const handleAssetChange = (e) => {
    let query = new URLSearchParams(window.location.search);
    let allProduct = [];
    if (getDefaultBody()?.product_type?.includes(e.target.value)) {
      if (e.target.value == "all") {
        allProduct = [];
      } else {
        allProduct = getDefaultBody()?.product_type?.filter(
          (data) => data !== e.target.value,
        );
      }
    } else {
      if (e.target.value == "all") {
        let assets = [
          "Bank Owned",
          "Foreclosure",
          "Short Sale",
          "Traditional",
          "all",
          "auction",
        ];
        allProduct = [
          ...getDefaultBody()?.product_type,
          ...assets,
          e.target.value,
        ];
      } else {
        allProduct = [...getDefaultBody()?.product_type, e.target.value];
      }
    }

    productType_val = allProduct;
    query.set("product_type", allProduct.length ? allProduct.toString() : "");
    getAllProperties(null, {
      ...body,
      product_type: allProduct,
      page: 1,
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
  };

  const handleSelectAllChange = () => {
    const newSelectAllState = !selectAll;
    setSelectAll(newSelectAllState);

    let allProperties = newSelectAllState
      ? checkedItems.map((item) => item.name)
      : [];
    setBody({ ...body, property_type: allProperties });

    let query = new URLSearchParams(window.location.search);
    query.set("page", 1);
    query.set(
      "property_type",
      allProperties.length ? allProperties.toString() : "",
    );
    getAllProperties(null, {
      ...body,
      property_type: allProperties.length ? allProperties : "",
      page: 1,
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
  };

  const handleCheckbox = (e) => {
    setIsChecked(!isChecked);
  };

  const handlebathCheckbox = (e) => {
    setIsbathChecked(!isbathChecked);
  };

  const handleStatusChange = (e) => {
    let query = new URLSearchParams(window.location.search);
    query.set("page", 1);
    let allProperty = [];
    if (body.status.includes(e.target.value)) {
      allProperty = body.status.filter((data) => data !== e.target.value);
    } else {
      allProperty = [...body.status, e.target.value];
    }
    query.set("status", allProperty.length ? allProperty.toString() : "");
    getAllProperties(null, {
      ...body,
      status: allProperty.length ? allProperty : "",
      page: 1,
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
  };

  const handleOccupencyChange = (e) => {
    let query = new URLSearchParams(window.location.search);
    query.set("page", 1);
    let allOccupency = [];
    if (getDefaultBody()?.occupency_type.includes(e.target.value)) {
      allOccupency = getDefaultBody()?.occupency_type.filter(
        (data) => data !== e.target.value,
      );
    } else {
      allOccupency = [...getDefaultBody()?.occupency_type, e.target.value];
    }
    query.set(
      "occupency_type",
      allOccupency.length ? allOccupency.toString() : "",
    );
    getAllProperties(null, {
      ...body,
      occupency_type: allOccupency.length ? allOccupency : "",
      page: 1,
    });
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + query.toString(),
    });
  };

  const handlePropertyFilters = (e, key) => {
    anchorRefs.current[key] = e.key;
    setAnchorSetEl(e);
  };

  const googleMapFilterButtons = [
    { label: "Asset Type", content: "asset_type" },
    { label: "Price Range", content: "price" },
    { label: "Beds & Baths", content: "bed" },
    { label: "Property Type", content: "home" },
    { label: "More", content: "additional" },
  ];

  const resetMore = () => {
    isResetting.current = true;
    let url = new URLSearchParams(global.defaultLocation);
    url.set("reset", "true");
    url.set("initial", "true");
    url.delete("searchbar");
    url.delete("inputReset");
    url.delete("isState");
    url.delete("isCity");
    setSearchQuery("");

    // Parse global.defaultLocation to get the complete default body
    const defaultQuery = qs.parse(global.defaultLocation?.slice(1) || "");
    const resetBodyState = {
      page: defaultQuery.page || 1,
      limit: 6,
      title: defaultQuery.title || "",
      ids: defaultQuery.ids ? defaultQuery.ids.split(",") : "",
      sortby: defaultQuery.sortby || "1",
      maxPrice: defaultQuery.maxPrice || "",
      minPrice: defaultQuery.minPrice || "",
      status: defaultQuery.status ? defaultQuery.status.split(",") : ["open"],
      listing_type: defaultQuery.listing_type
        ? defaultQuery.listing_type.split(",")
        : "",
      occupency_type: defaultQuery.occupency_type
        ? defaultQuery.occupency_type.split(",")
        : "",
      minbeds: defaultQuery.minBed || "",
      maxSqft: defaultQuery.maxSqft || "",
      minSqft: defaultQuery.minSqft || "",
      minLotSize: defaultQuery.minLotSize || "",
      maxLotSize: defaultQuery.maxLotSize || "",
      minYearbuilt: defaultQuery.minYearbuilt || "",
      maxYearbuilt: defaultQuery.maxYearbuilt || "",
      parking: defaultQuery.parking || "",
      exact_bathroom: defaultQuery.exact_bathroom
        ? defaultQuery.exact_bathroom
        : false,
      exact_bedroom: defaultQuery.exact_bedroom
        ? defaultQuery.exact_bedroom
        : false,
      maxbeds: defaultQuery.maxBed || "",
      garage: defaultQuery.garage == "yes" ? "yes" : "no",
      is_open_house: defaultQuery.is_open_house == "yes" ? "yes" : "no",
      is_3D_Tour: defaultQuery.is_3D_Tour == "yes" ? "yes" : "no",
      keywords: defaultQuery.keywords || "",
      minbathroom: defaultQuery.minBath || "",
      bedroom: defaultQuery.bedroom || "",
      bathroom: defaultQuery.bathroom || "",
      maxbathroom: defaultQuery.maxBath || "",
      property_type: defaultQuery.property_type
        ? defaultQuery.property_type.split(",")
        : "",
      product_type: defaultQuery.product_type
        ? defaultQuery.product_type.split(",")
        : "",
      minSize: defaultQuery.minSize ? defaultQuery.minSize.toString() : "",
      maxSize: defaultQuery.maxSize ? defaultQuery.maxSize.toString() : "",
      type: defaultQuery.type ? defaultQuery.type.split(",") : "",
      rPrice: defaultQuery.rPrice || null,
      bound:
        defaultQuery.north &&
        defaultQuery.south &&
        defaultQuery.east &&
        defaultQuery.west
          ? {
              north: defaultQuery.north,
              south: defaultQuery.south,
              east: defaultQuery.east,
              west: defaultQuery.west,
            }
          : {},
      zoom_level: defaultQuery.zoom_level || "13",
      initial: "true",
      searchbar: "",
      search_url:
        window.location.origin +
        window.location.pathname +
        "?" +
        url.toString(),
    };

    // Set the body state with complete default values
    setBody(resetBodyState);

    // Reset related states
    setSelectedLocationBound({
      north: defaultQuery.north || null,
      south: defaultQuery.south || null,
      east: defaultQuery.east || null,
      west: defaultQuery.west || null,
    });
    setIsChecked(false);
    setIsbathChecked(false);

    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + url.toString(),
    });

    setTimeout(() => {
      isResetting.current = false;
    }, 500);
  };

  useEffect(() => {
    // Add this at the top of your existing useEffect that listens to props.location.search
    const urlParams = new URLSearchParams(window.location.search);
    const reset = urlParams.get("reset");
    const initial = urlParams.get("initial");
    const inputReset = urlParams.get("inputReset");

    // Set the flag if either reset or initial page load
    if (inputReset === "true") {
      resetSearchbarChange("");
    }

    if (reset === "true") {
      isResetting.current = true;
      // Clear the flag after sufficient time for both component cycles
      setTimeout(() => {
        isResetting.current = false;
      }, 600);
    }

    if (!isResetting.current) {
      debouncedSetBodyState();
    } else {
    }
  }, [props.location.search]);

  const resetSearchbarChange = () => {
    let _url = new URLSearchParams(location.search);
    const defaultQuery = qs.parse(
      (global.defaultLocation || "").replace(/^\?/, ""),
    );

    _url.delete("inputReset");
    _url.delete("search_attempted");
    _url.delete("isDirect");
    _url.delete("isState");
    _url.delete("isCity");
    _url.set("searchbar", "");
    _url.set("page", "1");
    _url.set("lat", defaultQuery.lat || global.defaultLat);
    _url.set("long", defaultQuery.long || global.defaultLong);
    _url.set("north", defaultQuery.north || global.defaultNorth);
    _url.set("south", defaultQuery.south || global.defaultSouth);
    _url.set("east", defaultQuery.east || global.defaultEast);
    _url.set("west", defaultQuery.west || global.defaultWest);
    _url.set("zoom_level", defaultQuery.zoom_level || global.defaultZoomLevel);
    _url.set("title", defaultQuery.title || "United States");
    _url.set("cities", defaultQuery.cities || "");
    _url.set("state", defaultQuery.state || "");
    _url.set("initial", "true");

    setSearchQuery("");

    // Parse current URL parameters to preserve all existing filters
    const currentQuery = qs.parse(window.location.search?.slice(1));

    const currentBodyState = {
      page: currentQuery.page || 1,
      limit: 6,
      title: currentQuery.title || "",
      ids: currentQuery.ids ? currentQuery.ids.split(",") : "",
      sortby: currentQuery.sortby || "1",
      maxPrice: currentQuery.maxPrice || "",
      minPrice: currentQuery.minPrice || "",
      status: currentQuery.status ? currentQuery.status.split(",") : ["open"],
      listing_type: currentQuery.listing_type
        ? currentQuery.listing_type.split(",")
        : "",
      occupency_type: currentQuery.occupency_type
        ? currentQuery.occupency_type.split(",")
        : "",
      minbeds: currentQuery.minBed || "",
      maxSqft: currentQuery.maxSqft || "",
      minSqft: currentQuery.minSqft || "",
      minLotSize: currentQuery.minLotSize || "",
      maxLotSize: currentQuery.maxLotSize || "",
      minYearbuilt: currentQuery.minYearbuilt || "",
      maxYearbuilt: currentQuery.maxYearbuilt || "",
      parking: currentQuery.parking || "",
      exact_bathroom: currentQuery.exact_bathroom
        ? currentQuery.exact_bathroom
        : false,
      exact_bedroom: currentQuery.exact_bedroom
        ? currentQuery.exact_bedroom
        : false,
      maxbeds: currentQuery.maxBed || "",
      garage: currentQuery.garage == "yes" ? "yes" : "no",
      is_open_house: currentQuery.is_open_house == "yes" ? "yes" : "no",
      is_3D_Tour: currentQuery.is_3D_Tour == "yes" ? "yes" : "no",
      keywords: currentQuery.keywords || "",
      minbathroom: currentQuery.minBath || "",
      bedroom: currentQuery.bedroom || "",
      bathroom: currentQuery.bathroom || "",
      maxbathroom: currentQuery.maxBath || "",
      property_type: currentQuery.property_type
        ? currentQuery.property_type.split(",")
        : "",
      product_type: currentQuery.product_type
        ? currentQuery.product_type.split(",")
        : "",
      minSize: currentQuery.minSize ? currentQuery.minSize.toString() : "",
      maxSize: currentQuery.maxSize ? currentQuery.maxSize.toString() : "",
      type: currentQuery.type ? currentQuery.type.split(",") : "",
      rPrice: currentQuery.rPrice || null,
      bound:
        (defaultQuery.north || global.defaultNorth) &&
        (defaultQuery.south || global.defaultSouth) &&
        (defaultQuery.east || global.defaultEast) &&
        (defaultQuery.west || global.defaultWest)
          ? {
              north: defaultQuery.north || global.defaultNorth,
              south: defaultQuery.south || global.defaultSouth,
              east: defaultQuery.east || global.defaultEast,
              west: defaultQuery.west || global.defaultWest,
            }
          : {},
      lat: parseFloat(defaultQuery.lat || global.defaultLat),
      lng: parseFloat(defaultQuery.long || global.defaultLong),
      long: parseFloat(defaultQuery.long || global.defaultLong),
      north: parseFloat(defaultQuery.north || global.defaultNorth),
      south: parseFloat(defaultQuery.south || global.defaultSouth),
      east: parseFloat(defaultQuery.east || global.defaultEast),
      west: parseFloat(defaultQuery.west || global.defaultWest),
      zoom_level: defaultQuery.zoom_level || global.defaultZoomLevel || "13",
      initial: true,
      searchbar: "", // Only clear the searchbar
      search_url:
        window.location.origin +
        window.location.pathname +
        "?" +
        _url.toString(),
    };

    setSelectedLocationBound({
      north: defaultQuery.north || global.defaultNorth,
      south: defaultQuery.south || global.defaultSouth,
      east: defaultQuery.east || global.defaultEast,
      west: defaultQuery.west || global.defaultWest,
    });

    getAllProperties(null, currentBodyState);

    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + _url.toString(),
    });
  };

  const handleSearchbarChange = (searchQuery) => {
    // Prevent duplicate API calls by checking if the query is already in the URL
    const currentParams = new URLSearchParams(location.search);
    const currentSearchQuery = currentParams.get("searchbar");
    const currentSearchAttempted =
      currentParams.get("search_attempted") === "true";
    const isDirect = currentParams.get("isDirect") === "true";

    // For direct searches, always proceed regardless of duplicate status
    if (
      currentSearchQuery === searchQuery &&
      currentSearchAttempted &&
      !isDirect
    ) {
      console.log(
        "Search query unchanged and already attempted, skipping duplicate search",
      );
      return;
    }

    console.log("Processing search query:", searchQuery);

    // Always update the local state to reflect the current search
    setSearchQuery(searchQuery);

    let _url = new URLSearchParams(location.search);
    _url.delete("isState");
    _url.delete("isCity");

    // Only update the searchbar parameter if we have a valid query
    if (searchQuery && searchQuery.trim() !== "") {
      _url.set("searchbar", searchQuery);
      // For searches from the search page, always set isDirect to true
      _url.set("isDirect", "true");
    } else {
      _url.delete("isDirect");
    }

    // Clear search_attempted to allow new search
    _url.delete("search_attempted");

    // Update URL first to prevent race conditions
    props.history.replace({
      pathname: props.location.pathname,
      search: "?" + _url.toString(),
    });

    // Then trigger the API call with the search query
    getAllProperties(null, {
      ...body,
      searchbar: searchQuery,
      status: body?.status || ["open"],
      page: 1, // Reset to page 1 for new searches
    });
  };

  // End
  return (
    <Layout>
      <div className="srt-wrapper topMapFilterBox">
        <div className="search-filters-wrap">
          {!width && (
            <FormControl
              variant="outlined"
              className={`${
                !width ? classes.mobileFormControl : classes.formControl
              } mblSrchFrm`}
            ></FormControl>
          )}
          <div className="w-100">
            <div className="d-flex align-item-center justify-content-start PropertyfilterButtonGroup">
              {googleMapFilterButtons.map((data, index) => (
                <div key={index} className="PropertyfilterButton">
                  <Button
                    onClick={() => handlePropertyFilters(data.label, index)}
                    aria-controls={
                      anchorSetEl == data.label ? "menu-list-grow" : undefined
                    }
                    aria-haspopup="true"
                    className="filterBtn"
                    ref={(el) => (anchorRefs.current[data.label] = el)}
                  >
                    {data.label}
                    <span className="material-icons-outlined">
                      keyboard_arrow_down
                    </span>
                  </Button>
                  <Popper
                    open={anchorSetEl == data.label}
                    anchorEl={anchorRefs.current[data.label]}
                    placement={
                      data.label == "More" ? "bottom-end" : "bottom-start"
                    }
                    style={{ minWidth: "200px", zIndex: 99 }}
                    onClose={(e) => handleClose(e)}
                    className="mp-popper"
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <div className="PropertyfilterButtonGroup">
                        {" "}
                        {data.content == "asset_type" ? (
                          <div id="menu-list-grow">
                            <h5 className="filterMenuTit">Asset Type</h5>
                            <MenuList className="priceRangeMenuBody p-3">
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="all-real-estate"
                                  label="All Real Estate"
                                  value="all"
                                  checked={
                                    body && body?.product_type.includes("all")
                                      ? true
                                      : false
                                  }
                                  onchange={(e) => handleAssetChange(e)}
                                />
                              </MenuItem>
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="auction"
                                  label="Auctions"
                                  value="auction"
                                  checked={
                                    body &&
                                    body?.product_type.includes("auction")
                                      ? true
                                      : false
                                  }
                                  onchange={(e) => handleAssetChange(e)}
                                />
                              </MenuItem>
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="Bank Owned"
                                  label="Bank Owned"
                                  value="Bank Owned"
                                  checked={
                                    body &&
                                    body?.product_type.includes("Bank Owned")
                                      ? true
                                      : false
                                  }
                                  onchange={(e) => handleAssetChange(e)}
                                />
                              </MenuItem>
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="Foreclosure"
                                  label="Foreclosure"
                                  value="Foreclosure"
                                  checked={
                                    body &&
                                    body?.product_type.includes("Foreclosure")
                                      ? true
                                      : false
                                  }
                                  onchange={(e) => handleAssetChange(e)}
                                />
                              </MenuItem>
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="Short Sale"
                                  label="Short Sale"
                                  value="Short Sale"
                                  checked={
                                    body &&
                                    body?.product_type.includes("Short Sale")
                                      ? true
                                      : false
                                  }
                                  onchange={(e) => handleAssetChange(e)}
                                />
                              </MenuItem>
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="Traditional"
                                  label="Traditional"
                                  value="Traditional"
                                  checked={
                                    body &&
                                    body?.product_type.includes("Traditional")
                                      ? true
                                      : false
                                  }
                                  onchange={(e) => handleAssetChange(e)}
                                />
                              </MenuItem>
                            </MenuList>
                          </div>
                        ) : data.content == "price" ? (
                          <div
                            id="menu-list-grow"
                            className="priceRangeMenuBody"
                          >
                            <div
                              autoFocusItem={open.proType}
                              id="menu-list-grow"
                              // onKeyDown={handleListKeyDown}
                            >
                              <h5 className="filterMenuTit">Price Range</h5>
                              <div className="priceRangeMenuBody">
                                <div className="priceGridBox">
                                  <div className="suitable">
                                    <CustomSelect
                                      selectLabel={true}
                                      customLabel="Min Price"
                                      name="pricemin"
                                      value={body?.minPrice}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "minPrice")
                                      }
                                    >
                                      <option value={""}>Any Price</option>
                                      <option value={10000}>$10,000</option>
                                      <option value={25000}>$25,000</option>
                                      <option value={50000}>$50,000</option>
                                      <option value={75000}>$75,000</option>
                                      <option value={100000}>$100,000</option>
                                      <option value={150000}>$150,000</option>
                                      <option value={200000}>$200,000</option>
                                      <option value={300000}>$300,000</option>
                                      <option value={500000}>$500,000</option>
                                    </CustomSelect>
                                  </div>
                                  <span className="material-icons-outlined px-1 mt-4">
                                    remove
                                  </span>
                                  <div className="suitable">
                                    <CustomSelect
                                      selectLabel={true}
                                      customLabel="Max Price"
                                      name="pricemax"
                                      value={body?.maxPrice}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "maxPrice")
                                      }
                                    >
                                      <option value={10000}>$10,000</option>
                                      <option value={25000}>$25,000</option>
                                      <option value={50000}>$50,000</option>
                                      <option value={75000}>$75,000</option>
                                      <option value={100000}>$100,000</option>
                                      <option value={150000}>$150,000</option>
                                      <option value={200000}>$200,000</option>
                                      <option value={300000}>$300,000</option>
                                      <option value={500000}>$500,000</option>

                                      <option value={""}>Any Price</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : data.content == "bed" ? (
                          <div
                            id="menu-list-grow"
                            className="priceRangeMenuBody"
                          >
                            <h5 className="filterMenuTit">
                              Number of Bedrooms
                            </h5>
                            <div className="priceRangeMenuBody">
                              <label className="dropHeadings">Bedrooms</label>
                              <div className="etOtIZ">
                                {bedroomPartions.map((data, index) => (
                                  <Button
                                    key={index}
                                    className={
                                      data.name == body?.bedroom
                                        ? "selectedBtn"
                                        : null
                                    }
                                    onClick={(e) =>
                                      filterChangeFunc(
                                        data.name,
                                        "bedroom",
                                        "button",
                                      )
                                    }
                                  >
                                    {!isChecked && data.label === "Any"
                                      ? "Studio"
                                      : data.label}
                                    {!isChecked && data.label !== "Any"
                                      ? "+"
                                      : null}
                                  </Button>
                                ))}
                              </div>
                            </div>
                            <div
                              className="ps-2 pl-2"
                              style={{ width: "fit-content" }}
                            >
                              <MenuItem className="homeTypeMultiCheck">
                                <CheckBox
                                  name="Use Exact"
                                  label="Use Exact Match"
                                  checked={isChecked}
                                  onchange={(e) => handleCheckbox(e)}
                                />
                              </MenuItem>
                            </div>
                            <h5 className="filterMenuTit">
                              Number of Bathrooms
                            </h5>
                            <div className="priceRangeMenuBody">
                              <label className="dropHeadings">Bathrooms</label>
                              <div className="etOtIZ">
                                {bathroomPartions.map((data, index) => (
                                  <Button
                                    key={index}
                                    className={
                                      data.name == body?.bathroom
                                        ? "selectedBtn"
                                        : null
                                    }
                                    onClick={() =>
                                      filterChangeFunc(
                                        data.name,
                                        "bathroom",
                                        "button",
                                      )
                                    }
                                  >
                                    {data.label}
                                  </Button>
                                ))}
                              </div>
                              <div
                                className="ps-2 pl-2"
                                style={{ width: "fit-content" }}
                              >
                                <MenuItem className="homeTypeMultiCheck">
                                  <CheckBox
                                    name="Use Exact"
                                    label="Use Exact Match"
                                    checked={isbathChecked}
                                    onchange={(e) => handlebathCheckbox(e)}
                                  />
                                </MenuItem>
                              </div>
                            </div>
                          </div>
                        ) : data.content == "home" ? (
                          <div id="menu-list-grow">
                            <h5 className="filterMenuTit">Property Type</h5>
                            <MenuList className="priceRangeMenuBody p-3">
                              <div
                                className="selectAllChekbox"
                                onClick={handleSelectAllChange}
                              >
                                <span className="material-icons">
                                  check_circle
                                </span>{" "}
                                <div>
                                  {!selectAll ? "Select All" : "Deselect All"}
                                </div>
                              </div>
                              {checkedItems.map((data, index) => (
                                <MenuItem
                                  key={index}
                                  className="homeTypeMultiCheck"
                                >
                                  <CheckBox
                                    name={data.name}
                                    label={data.label}
                                    value={data.name}
                                    checked={
                                      body &&
                                      body?.property_type.includes(data.name)
                                        ? true
                                        : false
                                    }
                                    onchange={(e) => handleCheckboxChange(e)}
                                  />
                                </MenuItem>
                              ))}
                            </MenuList>
                          </div>
                        ) : data.content == "additional" ? (
                          <div id="menu-list-grow">
                            <h5 className="filterMenuTit">
                              {data.content === "additional"
                                ? "Filters"
                                : "Filters"}
                            </h5>
                            <div className="priceRangeMenuBody p-0">
                              <div
                                className="innerScrollerBody"
                                style={{ padding: "0 10px" }}
                              >
                                <div>
                                  <label className="dropHeadings">
                                    Occupancy
                                  </label>
                                  <div className="listingtabTypes">
                                    {occupancyOptions.map((data, index) => (
                                      <MenuItem
                                        key={index}
                                        className="homeTypeMultiCheck"
                                      >
                                        <CheckBox
                                          name={data.name}
                                          label={data.label}
                                          value={data.name}
                                          checked={
                                            body &&
                                            body?.occupency_type.includes(
                                              data.name,
                                            )
                                          }
                                          onchange={handleOccupencyChange}
                                        />
                                      </MenuItem>
                                    ))}
                                  </div>
                                </div>

                                {/* More Filters Section */}
                                <div>
                                  <label className="dropHeadings">
                                    Property Status
                                  </label>
                                  <div className="listingtabTypes">
                                    {propertyStatus.map((data, index) => (
                                      <MenuItem
                                        key={index}
                                        className="homeTypeMultiCheck"
                                      >
                                        <CheckBox
                                          name={data.name}
                                          label={data.label}
                                          value={data.name}
                                          checked={
                                            body &&
                                            body?.status.includes(data.name)
                                          }
                                          onchange={handleStatusChange}
                                        />
                                      </MenuItem>
                                    ))}
                                  </div>
                                </div>

                                <div>
                                  <label className="filterLabel dropHeadings">
                                    Square Feet (sq. ft)
                                  </label>
                                  <div className="propertyFieldsGrid mb-2">
                                    <CustomSelect
                                      selectLabel={true}
                                      customLabel="No Min"
                                      name="bathrooms"
                                      value={body?.minSqft}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "minSqft")
                                      }
                                    >
                                      <option value={""}>No Min</option>
                                      <option value={500}>500 sq. ft</option>
                                      <option value={750}>750 sq. ft</option>
                                      <option value={1000}>1000 sq. ft</option>
                                      <option value={1250}>1250 sq. ft</option>
                                      <option value={1500}>1500 sq. ft</option>
                                      <option value={1750}>1750 sq. ft</option>
                                      <option value={2000}>2000 sq. ft</option>
                                      <option value={2250}>2250 sq. ft</option>
                                      <option value={2500}>2500 sq. ft</option>
                                      <option value={2750}>2750 sq. ft</option>
                                      <option value={3000}>3000 sq. ft</option>
                                      <option value={3500}>3500 sq. ft</option>
                                      <option value={4000}>4000 sq. ft</option>
                                      <option value={5000}>5000 sq. ft</option>
                                      <option value={6000}>6000 sq. ft</option>
                                      <option value={7000}>7000 sq. ft</option>
                                    </CustomSelect>
                                    <CustomSelect
                                      selectLabel={true}
                                      customLabel="No Max"
                                      name="bathrooms"
                                      value={body?.maxSqft}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "maxSqft")
                                      }
                                    >
                                      <option value={500}>500 sq. ft</option>
                                      <option value={750}>750 sq. ft</option>
                                      <option value={1000}>1000 sq. ft</option>
                                      <option value={1250}>1250 sq. ft</option>
                                      <option value={1500}>1500 sq. ft</option>
                                      <option value={1750}>1750 sq. ft</option>
                                      <option value={2000}>2000 sq. ft</option>
                                      <option value={2250}>2250 sq. ft</option>
                                      <option value={2500}>2500 sq. ft</option>
                                      <option value={2750}>2750 sq. ft</option>
                                      <option value={3000}>3000 sq. ft</option>
                                      <option value={5000}>5000 sq. ft</option>
                                      <option value={3500}>3500 sq. ft</option>
                                      <option value={7000}>7000 sq. ft</option>
                                      <option value={4000}>4000 sq. ft</option>
                                      <option value={6000}>6000 sq. ft</option>
                                      <option value={""}>No Max</option>
                                    </CustomSelect>
                                  </div>

                                  <label className="filterLabel dropHeadings">
                                    Lot Size
                                  </label>
                                  <div className="propertyFieldsGrid mb-2">
                                    <CustomSelect
                                      selectLabel={true}
                                      customLabel="No Min"
                                      name="minlot"
                                      value={body?.minLotSize}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "minLotSize")
                                      }
                                    >
                                      <option value={""}>No Min</option>
                                      <option value={1000}>1000 acres</option>
                                      <option value={2000}>2000 acres</option>
                                      <option value={3000}>3000 acres</option>
                                      <option value={4000}>4000 acres</option>
                                      <option value={5000}>5000 acres</option>
                                      <option value={7500}>7500 acres</option>
                                      <option value={4}>1/4 acres</option>
                                      <option value={4}>1/2 acres</option>
                                      <option value={4}>1 acres</option>
                                      <option value={4}>2 acres</option>
                                      <option value={4}>5 acres</option>
                                      <option value={4}>10 acres</option>
                                      <option value={4}>20 acres</option>
                                      <option value={4}>50 acres</option>
                                      <option value={4}>100 acres</option>
                                    </CustomSelect>
                                    <CustomSelect
                                      selectLabel={true}
                                      customLabel="No Max"
                                      name="maxlot"
                                      value={body?.maxLotSize}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "maxLotSize")
                                      }
                                    >
                                      <option value={1000}>1000 acres</option>
                                      <option value={2000}>2000 acres</option>
                                      <option value={3000}>3000 acres</option>
                                      <option value={4000}>4000 acres</option>
                                      <option value={5000}>5000 acres</option>
                                      <option value={7500}>7500 acres</option>
                                      <option value={4}>1/4 acres</option>
                                      <option value={4}>1/2 acres</option>
                                      <option value={4}>1 acres</option>
                                      <option value={4}>2 acres</option>
                                      <option value={4}>5 acres</option>
                                      <option value={4}>10 acres</option>
                                      <option value={4}>20 acres</option>
                                      <option value={4}>50 acres</option>
                                      <option value={4}>100 acres</option>
                                      <option value={""}>No Max</option>
                                    </CustomSelect>
                                  </div>

                                  <label className="filterLabel dropHeadings">
                                    Year Built
                                  </label>
                                  <div className="propertyFieldsGrid">
                                    <CustomInput
                                      placeholder="No Min"
                                      name={"min"}
                                      value={body?.minYearbuilt}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "minYearbuilt")
                                      }
                                    />
                                    <CustomInput
                                      placeholder="No Max"
                                      value={body?.maxYearbuilt}
                                      name={"max"}
                                      onChange={(e) =>
                                        filterChangeFunc(e, "maxYearbuilt")
                                      }
                                    />
                                  </div>
                                </div>

                                {/* Keywords Filter */}
                                <CustomInput
                                  customLabel="Keywords"
                                  inputLabel={true}
                                  name={"keyword"}
                                  value={body?.keywords}
                                  onChange={(e) =>
                                    filterChangeFunc(e, "keywords")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </ClickAwayListener>
                  </Popper>
                </div>
              ))}
              <div className="saveSearBtn">
                <div>
                  <a
                    className="btn btn-primary"
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                    }}
                  >
                    Save Search
                  </a>

                  <Menu
                    open={openMenu}
                    onClose={() => setAnchorEl(null)}
                    anchorEl={anchorEl}
                    id="saved-menu"
                    className="saved-menu"
                    variant="menu"
                  >
                    <MenuItem className="search-saved">
                      <div className="d-flex">
                        <i className="material-icons mr-2">check_circle</i>
                        Search Saved!
                      </div>
                      <a className="ss-copy-link" onClick={copy}>
                        Copy Link
                      </a>
                    </MenuItem>

                    <MenuItem>
                      <div className="d-flex flex-column">
                        <CustomInput
                          placeholder="Enter Search"
                          name="searchName"
                          label="Name your search"
                          value={formik.values.searchName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          onKeyDown={onKeyDown}
                          error={
                            formik.touched.searchName &&
                            Boolean(formik.errors.searchName)
                          }
                          helperText={
                            formik.touched.searchName &&
                            formik.errors.searchName
                          }
                        />
                      </div>
                    </MenuItem>

                    <MenuItem>
                      <a
                        className="btn btn-primary"
                        onClick={() => {
                          formik.handleSubmit();
                        }}
                      >
                        Update
                      </a>
                    </MenuItem>
                  </Menu>
                </div>
              </div>
              {/* <div className="separation"></div> */}
              <SecondaryButton
                className="filterSectionBtns resetMoreBtn"
                onClick={resetMore}
              >
                Clear filters
              </SecondaryButton>
            </div>
            <div className="searchBarHere"></div>
          </div>
        </div>
      </div>
      <div className="search-wrapper">
        <div className={`search-left ${"mobile-sg-wrapper show-map"}`}>
          <MapComponent
            ref={mapRef}
            className="map-container"
            multipleLocation={true}
            locations={viewPropertyLocations}
            fullscreenControl={true}
            // zoomLevel={40}
            viewProperties={viewPropertyLocations}
            resetLocations={resetMore}
            setLoaded={setLoaded}
            selectedLocation={selectedLocation}
            handleMapCenterChange={handleMapCenterChange}
            selectedLocationBound={selectedLocationBound}
            handleMultipleBounds={handleMultipleBounds}
            height={"100%"}
            handleSearchbarChange={handleSearchbarChange}
          />
        </div>

        <div className={`search-right ${"show-map"}`}>
          <>
            <div className="sr-top">
              <h3 className="sr-top-head">Property for Sale</h3>
              <div className="d-flex glv-wrap align-items-center">
                <div className="no-results">
                  {isLoading ? "Loading..." : `${getCount} Results`}
                </div>
                <div className="selectWrapper ss-wrap ms-3">
                  <span>Sort by</span>
                  <select
                    value={body ? body.sortby : "1"}
                    onChange={onSortBy}
                    className="form-control"
                  >
                    <option value="1">Ending Soon</option>
                    <option value="2">Current Bid (High to Low)</option>
                    <option value="3">Current Bid (Low to High)</option>
                    <option value="4">Newest</option>
                    <option value="5">Most Comments</option>
                  </select>
                </div>
                {!!viewProperties.length && getCount > 6 && (
                  <div className="pagination-wrap ms-auto">
                    <Pagination
                      count={Math.ceil(getCount / 6)}
                      page={page}
                      onChange={searchPageChange}
                      siblingCount={3}
                      boundaryCount={2}
                    />
                  </div>
                )}
              </div>
            </div>
            {!isLoading ? (
              getCount == 0 ? (
                <div className="card card-body text-center  p-3 mt-3 mb-3">
                  No Properties Found
                </div>
              ) : (
                <>
                  <div
                    className={
                      width ? "sg-wrapper" : "sg-wrapper mobile-sg-wrapper"
                    }
                  >
                    <SearchGrid properties={viewProperties} />
                  </div>
                  {!!viewProperties.length && getCount > 6 && (
                    <div>
                      <Pagination
                        count={Math.ceil(getCount / 6)}
                        page={page}
                        onChange={searchPageChange}
                        siblingCount={3}
                        boundaryCount={2}
                      />
                    </div>
                  )}
                </>
              )
            ) : (
              <div className="card card-body text-center  p-3 mt-3 mb-3">
                Loading...
              </div>
            )}

            {!width && !map ? (
              <div className={`map-sort ${scrollTop ? "bottom" : "top"}`}>
                <div className="map-toggle" onClick={toggleMap}>
                  <i className="far fa-map"></i> Map
                </div>
                <div className="selectWrapper ss-wrap">
                  <span className="sort-icon">
                    <i className="fas fa-sort-amount-down"></i>
                  </span>
                  <select
                    value={body ? body.sortby : "1"}
                    onChange={onSortBy}
                    className="form-control"
                  >
                    <option value="1">Ending Soon</option>
                    <option value="2">Current Bid (High to Low)</option>
                    <option value="3">Current Bid (Low to High)</option>
                    <option value="4">Newest</option>
                    <option value="5">Most Comments</option>
                  </select>
                </div>
              </div>
            ) : (
              <div
                className={`map-sort list-toggle ${
                  scrollTop ? "bottom" : "top"
                }`}
              >
                <div className="map-toggle" onClick={toggleMap}>
                  <i className="far fa-map"></i> List
                </div>
              </div>
            )}
          </>
        </div>
      </div>
      <Featured />
      <Modal
        open={mobilePropertyPopupOpen}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div style={modalStyle} className={classes.paper}>
          {mobileSelectedPropertyId &&
          viewProperties.filter(
            (property) => property.id == mobileSelectedPropertyId,
          ).length > 0 ? (
            <SearchCard
              item={
                viewProperties.filter(
                  (property) => property.id == mobileSelectedPropertyId,
                )[0]
              }
              showTimer={true}
            />
          ) : (
            ""
          )}
        </div>
      </Modal>
    </Layout>
  );
};

export default Search;
